import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ExcelDownload from '../../../component/common/button/ExcelDownload.jsx';
import * as Icons from '../../../images/icons/icons_component.js';


function ConfirmCancel_popup() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = String(today.getMonth() + 1).padStart(2, '0'); // 다음 달
    const [data, setData] = useState([]);
    const [emog, setEmog] = useState([]);
    const [checkItems, setCheckItems] = useState([]);
    const [isSearched, setIsSearched] = useState(false);
    const [searchParams, setSearchParams] = useState({
        searchYear: currentYear,
        searchCheck1: currentMonth,
        searchEmog: '',
    });

    const dataHead = ['기관코드', '기관명', '당직년월일', '확정여부']; //component화 
    const dataColumn = ['EMOGCODE', 'EMOGDESC', 'BNDT_DE', 'CONFIRM_YN'];
    const apiCall = '/trmsapi/dutyschd/getConfirmCancelSearch.do';
    const excelFileName = '기관별_전담전문의 별 당직일수';
    const mergeConfig = [{ key: 'EMOGDESC', row: null }, { key: 'CLNICKWA_NM', row: null },]

    const fetchEmogList = async () => {
        try {
            const response = await axios.get('/ptmiapi/trmsEmogList.do', {
                params: {
                    grdc: 'Y',
                    loca: '',
                }
            });
            setEmog(response.data.emogList || []);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };

    const search = async () => {
        try {
            const response = await axios.get(apiCall, {
                params: searchParams,
            });
            setData(response.data);
            setIsSearched(true);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    }


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const handleAllCheck = (checked) => setCheckItems(checked ? [...data] : []);
    const handleSingleCheck = (checked, item) => {
        const originalItem = data.find((row) => row.SEQ === item.SEQ);
        if (!originalItem) return;
        setCheckItems((prev) =>
            checked
                ? [...prev, originalItem]
                : prev.filter((i) => i.SEQ !== item.SEQ)
        );
    };

    const cancel = async () => {
        if (checkItems.length === 0) {
            alert("선택한 데이터가 없습니다.");
            return;
        }
        const confirm = window.confirm(`${checkItems.length}건을 확정 취소처리 하시겠습니까?`);
        if (confirm) {
            const newRows = checkItems.map((item) => ({
                emogCode: item.EMOGCODE,
                bndtDe: item.BNDT_DE,
            }));
            const url = '/trmsapi/dutyschd/confirm_cancel.do';
            saveLogic(newRows, url);
            window.close();
        } else {
            return false;
        }
    };

    const saveLogic = async (data, url) => {
        const payload = new URLSearchParams({
            jsonStr: JSON.stringify(data),
            userId: localStorage.getItem("id"),
        });

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: payload,
            });

            if (!response.ok) {
                throw new Error(`서버 오류: ${response.status}`);
            }

            const resultText = await response.text();
            console.log('저장 결과:', resultText);

            alert('저장이 완료되었습니다.');
            window.close();
        } catch (error) {
            console.error('저장 중 오류 발생:', error);
            alert('저장에 실패했습니다. 관리자에게 문의하세요.');
        }
    };

    useEffect(() => {
        fetchEmogList();
    }, []);

    const computeRowSpans = (dataList, mergeConfig = [], allColumns = []) => {
        const rowSpans = dataList.map(() => ({}));

        mergeConfig.forEach(({ key: colKey, row, nullable }) => {
            let prevValue = null;
            let startIndex = 0;
            let mergeCount = 1;

            for (let i = 0; i < dataList.length; i++) {
                const currentValue = dataList[i][colKey];
                const isMergeable = nullable
                    ? currentValue === prevValue
                    : currentValue === prevValue && currentValue !== '' && currentValue !== null;

                if (isMergeable) {
                    if (row == null || mergeCount < row) {
                        rowSpans[startIndex][colKey] += 1;
                        rowSpans[i][colKey] = 0;
                        mergeCount += 1;
                    } else {
                        rowSpans[i][colKey] = 1;
                        startIndex = i;
                        mergeCount = 1;
                    }
                } else {
                    rowSpans[i][colKey] = 1;
                    startIndex = i;
                    mergeCount = 1;
                    prevValue = currentValue;
                }
            }
        });
        // 비병합 컬럼 처리
        dataList.forEach((_, i) => {
            allColumns.forEach(colKey => {
                if (!(colKey in rowSpans[i])) {
                    rowSpans[i][colKey] = 1;
                }
            });
        });
        return rowSpans;
    };

    const rowSpans = computeRowSpans(data, [{ key: 'EMOGCODE', row: null }, { key: 'EMOGDESC', row: null }], dataColumn);

    return (
        <div className='popup_container bg_tr_bg'>
            <h5>사후 근무표 확정 취소</h5>
            <div className='flex flex-col'>
                <div className="com-search tr_pop_th_bg" style={{ borderTop: 'var(--tr-primary-border' }}>
                    <table>
                        <colgroup>
                            <col width="10%" />
                            <col width="20%" />
                            <col width="10%" />
                            <col width="20%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>등록년월</th>
                                <td>
                                    <div className='flex gap-1'>
                                        <select
                                            id="searchYear"
                                            name="searchYear"
                                            value={searchParams.searchYear}
                                            onChange={handleInputChange}
                                        >
                                            <option value={searchParams.searchYear}>{searchParams.searchYear}년</option>
                                        </select>
                                        <select
                                            id="searchCheck1"
                                            name="searchCheck1"
                                            value={searchParams.searchCheck1}
                                            onChange={handleInputChange}
                                        >
                                            <option value={searchParams.searchCheck1}>{searchParams.searchCheck1}월</option>
                                        </select>
                                    </div>
                                </td>
                                <th>의료기관명</th>
                                <td>
                                    <select
                                        name='searchEmog'
                                        className='w-full'
                                        value={searchParams.searchEmog}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">선택</option>
                                        {emog.map(hosp => (
                                            <option key={hosp.emogcode} value={hosp.emogcode}>{hosp.emogdesc}</option>
                                        ))
                                        }
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='search_btn_wrapper'>
                    <span className='total_items'>전체&nbsp;<strong className='tr_primary'>{data.length}</strong>건</span>
                    <div className='btn_container'>
                        <button onClick={search} className='search_btn bg_tr_primary'><Icons.Search16w />검색</button>
                        <button onClick={cancel} className='search_btn bg_co_red'><Icons.CancelCircle16w />확정 취소</button>
                        <ExcelDownload
                            excelHead={dataHead}
                            excelData={data}
                            searched={isSearched}
                            dataCode={dataColumn}
                            excelFileName={excelFileName}
                            mergeData={mergeConfig}
                        />
                    </div>
                </div>
                <div>
                    <div class='data_grid_container'>
                        <hr className='border-t-2 mr-1-1 tr_border_soft' />
                        <div className='data_list_table tr_border_soft' style={{ maxHeight: '31rem' }}>
                            <table>
                                <thead>
                                    <tr>
                                        <th className='flex justify-center items-center'>
                                            {data.length > 0 && checkItems.length === data.length ?
                                                <Icons.CheckOk className='cursor-pointer' onClick={() => handleAllCheck(false)} />
                                                :
                                                <Icons.CheckNon className='cursor-pointer' onClick={() => handleAllCheck(true)} />
                                            }
                                        </th>
                                        {dataHead.map((h, i) => (
                                            <th key={i}>{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length === 0 ? (
                                        <tr>
                                            <td colSpan={1000} className='empty_box'>
                                                <span className={`data_empty bg_tr_odd`}>
                                                    {isSearched ? <Icons.EmptySalgu /> : <Icons.NullSalgu />}
                                                    {isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                        :
                                        (data.map((item, rowIndex) => {
                                            const rowSeq = item.SEQ;
                                            const isChecked = checkItems.some(i => i.SEQ === rowSeq);

                                            return (
                                                <tr key={rowSeq} className={item.isNew ? 'bg-yellow-100' : ''}>
                                                    <td className='flex justify-center items-center'>
                                                        {isChecked ?
                                                            <Icons.CheckOk className='cursor-pointer' onClick={() => handleSingleCheck(false, item)} />
                                                            :
                                                            <Icons.CheckNon className='cursor-pointer' onClick={() => handleSingleCheck(true, item)} />
                                                        }
                                                    </td>
                                                    {dataColumn.map((col, colIndex) => {
                                                        const span = rowSpans?.[rowIndex]?.[col];
                                                        if (span === 0) return null;
                                                        return (
                                                            <td key={colIndex} rowSpan={span}>
                                                                {item[col]}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        }))}
                                </tbody>
                            </table>
                        </div>
                        <hr className='mr-1-1 co_border_gray' />
                    </div>
                </div>
            </div>
        </div>
    );
}



export default ConfirmCancel_popup;